export var EmployeeRole;
(function (EmployeeRole) {
    EmployeeRole["EMPLOYEE"] = "EMPLOYEE";
})(EmployeeRole || (EmployeeRole = {}));
